export default "__VITE_ASSET__nINl$J0i__"